<template>
  <img :src="computedSource" @error="computedSource = fallback">
</template>

<script setup lang="ts">

import {ref} from "vue";

const props = defineProps({
  fallback: {
    type: String,
    default: '/projects/dw/gmf/assets/images/preview.jpg?v2025',
  },
  src: {
    type: String,
    required: true,
  }
});

const computedSource = ref(`${props.src}?nocache=${(new Date()).getMinutes()}`);
</script>
